import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';

import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';

import List from './List';

export default class Logos extends Component {
  static propTypes = {
    children: PropTypes.node,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = List

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      loading: true,
    };
  }
  componentDidMount() {
    this.fetchLogos();
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchLogos() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM('/logos/?page=1', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      await this.setComponentState({
        token,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        loading: this.state.loading,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Logos/Logos.jsx